import { alias, createModelSchema } from "serializr";
import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { RewardModel } from "@/modules/redactor/models/reward/RewardModel";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleTimeLimited extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.TIME_LIMITED);

        this._product = null;
        this._reward = null;

        this._durationTime = 0;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get durationTime() {
        return this._durationTime;
    }

    set durationTime(value) {
        this._durationTime = value;
    }

    valid() {

        if (!this.product || this.product.length === 0) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (!Number.isInteger(this.durationTime) || this.durationTime < 0) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.product || this.product.length === 0) {
            return true;
        }

        if (!this.reward || this.reward.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleTimeLimited());
        } else if (target instanceof SmartOfferBundleTimeLimited) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleTimeLimited, {
    _product: alias("product", Schema.primitive()),
    _reward: alias("reward", RewardModel.schema()),
    _durationTime: alias("duration_time", Schema.primitive())
});
